/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptFriendInviteResponse
 */
export interface AcceptFriendInviteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AcceptFriendInviteResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof AcceptFriendInviteResponse
     */
    message: string;
}

/**
 * Check if a given object implements the AcceptFriendInviteResponse interface.
 */
export function instanceOfAcceptFriendInviteResponse(value: object): value is AcceptFriendInviteResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function AcceptFriendInviteResponseFromJSON(json: any): AcceptFriendInviteResponse {
    return AcceptFriendInviteResponseFromJSONTyped(json, false);
}

export function AcceptFriendInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptFriendInviteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function AcceptFriendInviteResponseToJSON(json: any): AcceptFriendInviteResponse {
    return AcceptFriendInviteResponseToJSONTyped(json, false);
}

export function AcceptFriendInviteResponseToJSONTyped(value?: AcceptFriendInviteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

